import {Controller} from "stimulus"

// The GL accounts index filter bar. Every change rebuilds the index URL from
// the Show Inactive checkbox and both multi-selects and navigates to it;
// Ledger::AccountSearch reads it back.
export default class extends Controller {
    static targets = ["all", "funds", "majorTypes", "status"];

    disconnect() {
        clearTimeout(this.delayTimer);
    }

    reload() {
        this.announce("Updating the list…");
        const query = new URLSearchParams({all: this.allTarget.checked});
        // Type names hold spaces, so each value travels whole as its own
        // fund_ids[] / major_types[] element rather than comma-joined.
        this.selectedValues(this.fundsTarget).forEach(id => query.append("fund_ids[]", id));
        this.selectedValues(this.majorTypesTarget).forEach(type => query.append("major_types[]", type));
        this.navigateTo("/gl_accounts?" + query.toString());
    }

    // Multi-selects fire on every pick, so wait for the user to finish.
    reloadAfterPicking() {
        clearTimeout(this.delayTimer);
        this.announce("The list updates when you finish picking…");
        this.delayTimer = setTimeout(() => this.reload(), 1500);
    }

    // Tells the user a reload is pending, and screen readers through the
    // status region, since the page changes without a button press.
    announce(message) {
        if (this.hasStatusTarget) this.statusTarget.textContent = message;
    }

    selectedValues(select) {
        return Array.from(select.selectedOptions).map(option => option.value);
    }

    // The single seam that leaves the page; jsdom does not implement
    // navigation, so the tests spy on this.
    navigateTo(url) {
        window.location.href = url;
    }
}
